var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-form',{staticClass:"form"},[_c('div',{staticClass:"inputBox"},[_c('BaseInput',{attrs:{"label":_vm.$vuetify.breakpoint.mdAndUp ? 'Персональный номер сотрудника в ProApp' : null,"value":"SB0001","placeholder":"номер в ProApp","disabled":""}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }